import React, { Fragment, useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import PageTitle2 from '../../components/pagetitle/PageTitle2'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { API_URL } from '../../constant'

function MyWalletPage() {
  const [topCoinTotal, setTopCoinTotal] = useState(0);
  const [topCoinPoints, setTopCoinPoints] = useState(Array(12).fill(0));
  const [topCoinLoading, setTopCoinLoading] = useState(true);

  const [allocatedAmount, setAllocatedAmount] = useState(0);
  const [allocatedLoading, setAllocatedLoading] = useState(true);

  const currentMonthIndex = new Date().getMonth();

  useEffect(() => {
    const fetchTopCoins = async () => {
      try {
        const response = await fetch(`${API_URL}/api/public/wallet/chart-data`);
        if (!response.ok) {
          throw new Error('Failed to fetch chart data');
        }
        const data = await response.json();
        const points = Array.isArray(data?.monthly_points) ? data.monthly_points : [];

        // Ensure we have 12 slots; pad missing months with 0
        const normalizedPoints = Array.from({ length: 12 }, (_, idx) => Number(points[idx]) || 0);
        setTopCoinPoints(normalizedPoints);

        // Use current month only
        const currentMonthValue = Number(normalizedPoints[currentMonthIndex]) || 0;
        setTopCoinTotal(currentMonthValue);
      } catch (err) {
        console.error('Error fetching chart data:', err);
        setTopCoinPoints(Array(12).fill(0));
        setTopCoinTotal(0);
      } finally {
        setTopCoinLoading(false);
      }
    };

    fetchTopCoins();
  }, []);

  useEffect(() => {
    const fetchAllocatedDiscount = async () => {
      try {
        setAllocatedLoading(true);
        const response = await fetch(`${API_URL}/api/public/wallet/chart-data`);
        if (!response.ok) {
          throw new Error('Failed to fetch cash data');
        }

        const data = await response.json();

        let cashValues = [];
        if (Array.isArray(data?.cumulative_cash_values)) {
          cashValues = data.cumulative_cash_values;
        } else if (Array.isArray(data?.monthly_cash_values)) {
          cashValues = data.monthly_cash_values;
        } else if (Array.isArray(data?.monthly_data)) {
          cashValues = data.monthly_data.map((m) => Number(m?.cash_value) || 0);
        } else if (Array.isArray(data?.monthly_points)) {
          const rate = Number(data?.overall_stats?.conversion_rate) || 0.005;
          cashValues = data.monthly_points.map((p) => (Number(p) || 0) * rate);
        }

        const normalizedCash = Array.from({ length: 12 }, (_, idx) => Number(cashValues[idx]) || 0);

        // Use current month cash value only
        const currentMonthCash = Number(normalizedCash[currentMonthIndex]) || 0;

        setAllocatedAmount(currentMonthCash);
      } catch (err) {
        console.error('Error fetching cash data:', err);
        setAllocatedAmount(0);
      } finally {
        setAllocatedLoading(false);
      }
    };

    fetchAllocatedDiscount();
  }, []);

  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle2 pageTitle={"My Wallet"} pagesub={"Home"} />

          <section className="wallet-page section_space pt-30 pb-5 mt-5 text-dark">
            <div className="container">
              <div className="row g-4">
                <div className="col-12">
                  <div className="wallet-card">
                    <h5 className="wallet-heading">My Wallet overview</h5>
                    <p className="wallet-text">
                      Your My Wallet area shows how TopCoin rewards and merchant-issued discounts are recorded when you shop with participating businesses.
                    </p>
                    <p className="wallet-text">TopCoin UK operates as an advertising and loyalty platform.</p>
                    <p className="wallet-text">All rewards shown are free, merchant-funded discounts and not investments.</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="wallet-card h-100">
                    <h6 className="wallet-title">TopCoin Wallet</h6>
                    <p className="wallet-label mb-2">
                      TopCoins Collected:
                      <span className="wallet-inline-value">
                        {/* {topCoinLoading ? 'loading... ' : `${topCoinTotal.toLocaleString()}`} */}1,250 TopCoins
                      </span>
                    </p>
                    <p className="wallet-text">TopCoins are loyalty units issued by participating shops when you make purchases.</p>
                    <ul className="wallet-list">
                      <li>Issued free of charge by shops</li>
                      <li>Used to track shopping activity and discounts</li>
                      <li>TopCoins do not grow in value</li>
                      <li>TopCoins are not money or a financial product</li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="wallet-card h-100">
                    <h6 className="wallet-title">Bonus (Bounce) Wallet</h6>
                    <p className="wallet-label">
                      Bonus Discount Recorded:
                      <span className="wallet-inline-value">
                        £15.00
                      </span>
                    </p>
                    {/* <p className="wallet-inline-value">0</p> */}
                    <p className="wallet-text">The Bonus Wallet records additional merchant-issued discount amounts linked to the TopCoins you have received.</p>
                    <ul className="wallet-list">
                      <li>Represents bonus discount recognition only</li>
                      <li>Has no standalone or independent value</li>
                      <li>Recorded according to system rules</li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="wallet-card h-100">
                    <h6 className="wallet-title">Reward Cash Wallet</h6>
                    <p className="wallet-label mb-2">
                      Allocated Discount Amount:
                      <span className="wallet-inline-value">
                        {/* {allocatedLoading
                          ? '[ loading... ]'
                          : `£ ${allocatedAmount.toLocaleString('en-GB', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`} */}
                            £8.50
                      </span>
                    </p>
                    <p className="wallet-label">Status: Available / Locked</p>
                    <p className="wallet-text">The Reward Cash Wallet shows your allocated share of merchant-issued discounts.</p>
                    <ul className="wallet-list">
                      <li>Discounts originate from participating shops</li>
                      <li>Allocations are based on TopCoins collected</li>
                      <li>Displays discount amounts attributed to your activity</li>
                    </ul>
                    <p className="wallet-footnote">Where applicable, discounts may be settled as rebates, subject to system rules and merchant terms.</p>
                  </div>
                </div>

                <div className="col-12">
                  <div className="wallet-card notice-card">
                    <h6 className="wallet-title mb-2">Important Notice</h6>
                    <p className="wallet-text mb-1">All amounts shown represent merchant-issued discounts for illustration purposes only.</p>
                    <p className="wallet-text mb-1">This is not a bank account, investment, savings product, or guarantee of value.</p>
                    <p className="wallet-text mb-0">TopCoin UK does not issue money or hold customer funds.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <Scrollbar />
      </div>

      <style>{`
        .wallet-page {
           margin-top: 48px;
           padding-top: 72px;
        }

        .wallet-page {
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-page .wallet-card {
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-heading {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #111;
        }

        .wallet-title {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 10px;
          color: #111;
        }

        .wallet-label {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 6px;
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-value {
          font-size: 16px;
          font-weight: 700;
          color: var(--bs-dark-text-emphasis, #0f172a);
          margin-bottom: 10px;
        }

        .wallet-inline-value {
          font-size: 16px;
          font-weight: 700;
          color: var(--bs-dark-text-emphasis, #0f172a);
          margin-left: 8px;
          display: inline;
        }

        .wallet-text {
          font-size: 16px;
          color: var(--bs-dark-text-emphasis, #1f2937);
          margin-bottom: 8px;
          line-height: 1.5;
        }

        .wallet-list {
          padding-left: 25px;
          margin-bottom: 10px;
          color: var(--bs-dark-text-emphasis, #1f2937);
          font-size: 16px;
          line-height: 1.5;
        }

        .wallet-list li {
          margin-bottom: 4px;
        }

        .wallet-footnote {
          font-size: 16px;
          color: #4b5563;
          margin-bottom: 0;
        }

        .notice-card {
          background: #f9fafb;
          border-color: #e5e7eb;
        }

        @media (max-width: 991px) {
          .wallet-page .wallet-card {
            padding: 16px;
          }

          .g-4, .gy-4 {
            --bs-gutter-y: 0rem; 
          }

          .wallet-heading {
            font-size: 17px;
          }

          .wallet-title {
            font-size: 15px;
          }

          .wallet-text,
          .wallet-list,
          .wallet-label,
          .wallet-value {
            font-size: 13px;
          }
        }

        @media (max-width: 575px) {
          .wallet-page .wallet-card {
            padding: 14px;
          }

          .g-4, .gy-4 {
            --bs-gutter-y: 0rem; 
          }

          .wallet-heading {
            font-size: 16px;
          }

          .wallet-title {
            font-size: 14px;
          }

          .wallet-text,
          .wallet-list,
          .wallet-label,
          .wallet-value {
            font-size: 12.5px;
          }
        }
      `}</style>
    </Fragment>        
  )
}

export default MyWalletPage